import { splitTextAndLinks } from "@src/pages/subGroupDetail/SubgroupDetailPage.utils";
import { type WishListPdfEntry } from "@src/pages/wishlist/components/pdf/components/tableRow/TableRow";
import { type WishlistEntryModel } from "@src/pages/wishlist/Wishlist.utils";
import { SPFAvailabilityStatus } from "@src/utils/events";
import { type IntlShape } from "react-intl";

export const mapWishlistEntry = (entry: WishlistEntryModel, intl: IntlShape): WishListPdfEntry => {
    let modelDetails = `${entry.model.year}`;
    if (entry.model.modelSpecifications) modelDetails += entry.model.modelSpecifications.map((item) => ` / ${item.name}`);
    modelDetails += ` / ${entry.model.articleNumber}`;

    return {
        article: {
            name: entry.article?.name ?? "",
            articleNumber: entry.article?.articleNumber ?? "",
        },
        model: {
            description: `${entry.model.brand?.name} ${entry.model.description}`,
            details: modelDetails,
            brand: entry.model.brand?.shortName,
        },
        info: {
            price: intl.formatNumber(entry.clientArticleInfo?.price ?? 0, { style: "currency", currency: entry.clientArticleInfo?.currency }),
            availability: entry.clientArticleInfo?.availability ?? SPFAvailabilityStatus.Unknown,
            quantity: entry.quantity ?? 0,
        },
    };
};

export const trimSpaces = (s: string) => {
    s = s.replace(/(^\s*)|(\s*$)/gi, "");
    s = s.replace(/[ ]{2,}/gi, " ");
    s = s.replace(/\n /, "\n");

    return s;
};

export const resolveDisclaimerText = (disclaimer: string): string => {
    const splitText = splitTextAndLinks(disclaimer);

    return splitText
        .map((element) => {
            if (typeof element === "object") {
                return element.text;
            }

            return element;
        })
        .join(" ");
};
